import { useState } from 'react';

const Avatar = ({ src, name = 'Account', className = 'h-10 w-10', alt = '' }) => {
  const [failedSrc, setFailedSrc] = useState('');
  const safeName = name || 'Account';
  const initials = safeName.trim().split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase();
  const showImage = Boolean(src) && src !== failedSrc;

  return (
    <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-red-100 to-orange-100 font-bold text-[#9f2525] ${className}`} aria-label={alt || safeName}>
      {showImage ? (
        <img src={src} alt={alt} className="h-full w-full object-cover" onError={() => setFailedSrc(src)} />
      ) : (
        <span className="select-none text-[0.72em]" aria-hidden="true">{initials || 'A'}</span>
      )}
    </span>
  );
};

export default Avatar;
